"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSearchCompact = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const textinput_1 = __importDefault(require("../../textinput/textinput"));
const smartlabel_1 = __importDefault(require("../../smartlabel/smartlabel"));
const icons_1 = require("../../../icons");
const status_1 = require("../../constants/status");
class FieldSearchCompact extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            inputHasFocus: false
        };
        this.id = lodash_uniqueid_1.default('fsc_');
        this.handleFocus = () => {
            this.setState({
                inputHasFocus: true
            });
        };
        this.handleBlur = () => {
            this.setState({
                inputHasFocus: false
            });
        };
        this.handleChange = e => {
            this.props.onValueChange(e);
        };
        this.render = () => {
            const { value, label, inputRef, disabled, invalid, caution, valid, modified, maxWidth } = this.props;
            const { inputHasFocus } = this.state;
            let status;
            if (invalid) {
                status = status_1.STATUS_INVALID;
            }
            else if (caution) {
                status = status_1.STATUS_CAUTION;
            }
            else if (valid) {
                status = status_1.STATUS_VALID;
            }
            else if (modified) {
                status = status_1.STATUS_MODIFIED;
            }
            else {
                status = null;
            }
            const labelProps = {
                text: label,
                forId: this.id,
                inputHasFocus,
                inputHasValue: !!value,
                status,
                maxWidth
            };
            const inputProps = {
                id: this.id,
                value,
                type: 'search',
                placeholder: label,
                inputRef,
                suffix: jsx_runtime_1.jsx(icons_1.icons.Loupe, { size: 17 }, void 0),
                handleChange: this.handleChange,
                handleFocus: this.handleFocus,
                handleBlur: this.handleBlur,
                status,
                disabled
            };
            return (jsx_runtime_1.jsx(smartlabel_1.default, Object.assign({}, labelProps, { children: jsx_runtime_1.jsx(textinput_1.default, Object.assign({}, inputProps), void 0) }), void 0));
        };
    }
}
exports.FieldSearchCompact = FieldSearchCompact;
FieldSearchCompact.propTypes = {
    label: prop_types_1.default.string.isRequired,
    onValueChange: prop_types_1.default.func.isRequired,
    inputRef: prop_types_1.default.func,
    value: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    invalid: prop_types_1.default.bool,
    caution: prop_types_1.default.bool,
    valid: prop_types_1.default.bool,
    modified: prop_types_1.default.bool,
    maxWidth: prop_types_1.default.bool
};
FieldSearchCompact.defaultProps = {
    inputRef: () => { },
    value: '',
    disabled: false,
    invalid: false,
    caution: false,
    valid: false,
    modified: false,
    maxWidth: false
};
exports.default = FieldSearchCompact;
//# sourceMappingURL=field.search.compact.js.map